import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav_home: 'Accueil',
    nav_services: 'Services',
    nav_gallery: 'Galerie',
    nav_about: 'À propos',
    nav_contact: 'Contact',
    nav_quote_btn: 'Demander un devis',

    // Hero Section
    hero_badge: 'Artisanat d\'Excellence à Mbour',
    hero_title: 'Mobilier & Agencement en Bois Noble',
    hero_subtitle: 'Des créations sur mesure alliant savoir-faire traditionnel sénégalais et design contemporain pour sublimer vos espaces.',
    hero_cta_primary: 'Découvrir nos réalisations',
    hero_cta_secondary: 'Demander un devis gratuit',

    // Stats
    stat_years: 'Années d\'expérience',
    stat_projects: 'Projets réalisés',
    stat_satisfaction: 'Satisfaction clients',
    stat_guarantee: 'Garantie qualité',

    // Gallery Page
    gallery_header_title: 'Notre Galerie',
    gallery_header_subtitle: 'Découvrez nos réalisations et notre savoir-faire à travers nos créations uniques',
    cat_all: 'Toutes les réalisations',
    cat_furniture: 'Meubles sur mesure',
    cat_kitchen: 'Cuisines',
    cat_decor: 'Décoration & Salons',
    cat_renovation: 'Restauration & Rénovation',
    gallery_cta_title: 'Envie d\'une création similaire ?',
    gallery_cta_subtitle: 'Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.',

    // Gallery Page - images (12 réalisations)
    gal1_alt: 'Table à manger monumentale en bois massif teck et acajou',
    gal1_title: 'Table à Manger d\'Exception',
    gal1_desc: 'Table conviviale façonnée en teck africain massif avec plateau poli et piètement robuste fait main à Mbour.',
    gal2_alt: 'Grand dressing sur mesure en bois noble avec penderies',
    gal2_title: 'Dressing & Armoire sur Mesure',
    gal2_desc: 'Agencement de rangement personnalisé offrant des penderies spacieuses et des tiroirs aux finitions satinées.',
    gal3_alt: 'Meuble TV mural contemporain et bibliothèque en acajou',
    gal3_title: 'Ensemble TV & Bibliothèque Murale',
    gal3_desc: 'Structure murale élégante en acajou massif alliant support TV épuré et étagères d\'exposition rétroéclairées.',
    gal4_alt: 'Meuble buffet bas de rangement en bois massif',
    gal4_title: 'Buffet Bas & Console de Rangement',
    gal4_desc: 'Mobilier fonctionnel aux lignes épurées, conçu pour sublimer vos espaces de vie avec du bois durable.',
    gal5_alt: 'Commode et buffet sculpté à la main en bois d\'acajou',
    gal5_title: 'Commode Sculptée d\'Artisanat',
    gal5_desc: 'Pièce d\'ébénisterie d\'exception agrémentée de détails géométriques sculptés à la main dans du bois noble.',
    gal6_alt: 'Ensemble de salon en bois massif avec fauteuils et table basse',
    gal6_title: 'Salon complet en Bois Noble',
    gal6_desc: 'Ensemble assorti comprenant fauteuils ergonomiques et table basse centrale au charme authentique.',
    gal7_alt: 'Cuisine intégrée sur mesure en teck massif et plan de travail marbre',
    gal7_title: 'Cuisine Aménagée Teck & Marbre',
    gal7_desc: 'Cuisine sur mesure combinant la résistance naturelle du teck noble à l\'élégance du marbre blanc.',
    gal8_alt: 'Dressing modulable haut de gamme avec éclairage LED',
    gal8_title: 'Dressing Premium avec Éclairage LED',
    gal8_desc: 'Espace dressing modulable et luxueux doté de spots à LED intégrés et de finitions bois soignées.',
    gal9_alt: 'Table basse artisanale avec gravures traditionnelles sénégalaises',
    gal9_title: 'Table Basse Sculptée à la Main',
    gal9_desc: 'Table de salon sculptée avec précision par nos maîtres artisans, véritable chef-d\'œuvre de menuiserie.',
    gal10_alt: 'Cuisine équipée contemporaine sur mesure',
    gal10_title: 'Cuisine Intégrée Contemporaine',
    gal10_desc: 'Conception de cuisine fonctionnelle et lumineuse adaptée aux exigences des résidences modernes.',
    gal11_alt: 'Buffet en teck massif noble pour salle à manger',
    gal11_title: 'Buffet Bahut de Salle à Manger',
    gal11_desc: 'Bahut spacieux avec portes battantes et étagères intérieures pour un rangement élégant de votre vaisselle.',
    gal12_alt: 'Lit king size et chevets en acajou massif',
    gal12_title: 'Suite Parentale & Lit King Size',
    gal12_desc: 'Cadre de lit monumental en acajou noble avec tête de lit intégrée et chevets suspendus assortis.',
    gal13_alt: 'Cuisine moderne avec îlot en marbre, façades anthracite et bois de noyer',
    gal13_title: 'Cuisine Îlot Marbre & Noyer',
    gal13_desc: 'Grand îlot en marbre veiné avec habillage bois rétroéclairé, façades anthracite mates et niches vitrées éclairées.',
    gal14_alt: 'Cuisine blanche à cadres et caissons hauts en chêne avec poignées dorées',
    gal14_title: 'Cuisine Blanc, Chêne & Laiton',
    gal14_desc: 'Façades blanches à cadre, meubles hauts en chêne et vitrines éclairées, sublimées par des poignées en laiton brossé.',
    gal15_alt: 'Cuisine beige avec îlot en marbre et habillage en lames de noyer',
    gal15_title: 'Cuisine Ouverte Beige & Noyer',
    gal15_desc: 'Îlot central en marbre habillé de lames de noyer, façades beige sans poignées et bandeaux LED chaleureux.',
    gal16_alt: 'Cuisine en L en bois de noyer avec crédence en marbre',
    gal16_title: 'Cuisine en L Noyer & Marbre',
    gal16_desc: 'Agencement en L optimisé pour les espaces compacts, alliant façades en noyer, plan et crédence effet marbre.',

    // Services Page
    services_title: 'Nos Services',
    services_subtitle: 'Un savoir-faire complet en menuiserie et ébénisterie pour concrétiser tous vos projets.',
    service1_title: 'Menuiserie sur Mesure',
    service1_desc: 'Conception et fabrication de meubles uniques adaptés à vos dimensions et exigences.',
    service2_title: 'Aménagement d\'Intérieur',
    service2_desc: 'Cuisines intégrées, dressings et bibliothèques agencés pour optimiser votre espace.',
    service3_title: 'Restauration de Mobilier',
    service3_desc: 'Rénovation d\'art et traitement de bois nobles pour redonner vie à vos meubles anciens.',
    service4_title: 'Menuiserie Électrique & Finitions',
    service4_desc: 'Éclairages LED intégrés, finitions vernies ou huilées pour un rendu haut de gamme.',

    // Home Page Features
    home_preview_title: 'Savoir-Faire & Prestations',
    home_about_title: 'Un Héritage Artisanal à Mbour',
    home_about_desc: 'Basé à Mbour sur la route de Joal, notre atelier conçoit et fabrique des meubles d\'exception en bois noble (Teck, Acajou, Iroko). Nous accordons une attention minutieuse à chaque assemblage et finition.',
    home_feature1: 'Bois massif 100% noble et sélectionné',
    home_feature2: 'Finitions personnalisées et huiles naturelles',
    home_feature3: 'Livraison & installation sur toute la Petite Côte et à Dakar',
    home_cta_title: 'Un Projet de Mobilier en Tête ?',
    home_cta_desc: 'Contactez nos ébénistes dès aujourd\'hui pour obtenir une étude gratuite et sur mesure.',

    // About Page
    about_title: 'À Propos de Sénégalaise Déco',
    about_subtitle: 'Artisanat d\'excellence, passion du bois et tradition ébéniste à Mbour.',
    about_story_title: 'Notre Histoire',
    about_story_p1: 'Fondée à Mbour sur la route de Joal, Sénégalaise Déco Menuiserie perpétue l\'artisanat du bois au Sénégal.',
    about_story_p2: 'Nous combinons les essences de bois locales avec des lignes contemporaines pour créer des meubles d\'art durables.',
    about_values_title: 'Nos Valeurs',
    val_quality: 'Qualité Sans Compromis',
    val_quality_desc: 'Chaque pièce est soigneusement travaillée pour résister aux épreuves du temps.',
    val_craft: 'Savoir-Faire Artisanal',
    val_craft_desc: 'Des techniques de découpe et d\'assemblage traditionnelles transmises par des maîtres artisans.',
    val_custom: 'Sur Mesure Total',
    val_custom_desc: 'Conception personnalisée selon vos plans, vos goûts et l\'agencement de vos pièces.',

    // Contact Page
    contact_title: 'Contactez-Nous',
    contact_subtitle: 'Discutons de votre projet et créons ensemble votre mobilier d\'exception.',
    form_name: 'Nom complet',
    form_email: 'Adresse email',
    form_phone: 'Téléphone / WhatsApp',
    form_subject: 'Sujet du projet',
    form_message: 'Votre message / Détails du meuble',
    form_submit: 'Envoyer ma demande',
    form_success: 'Votre message a été envoyé avec succès ! Nous vous recontacterons très vite.',
    contact_address: 'Adresse de l\'Atelier',
    contact_phone: 'Téléphone & WhatsApp',
    contact_email: 'Email direct',
    contact_hours: 'Heures d\'ouverture',
    contact_hours_val: 'Lun - Sam : 08h00 - 18h00',

    // Services Page - header (page complète, distincte de l'aperçu Accueil)
    services_page_subtitle: 'Découvrez notre gamme complète de services d\'artisanat du meuble',
    price_on_request: 'Sur devis',

    svc1_title: 'Fabrication sur mesure',
    svc1_desc: 'Création de meubles personnalisés selon vos spécifications exactes. Nous adaptons chaque pièce à vos besoins et à votre espace.',
    svc1_f1: 'Mesures précises de votre espace',
    svc1_f2: 'Design personnalisé selon votre style',
    svc1_f3: 'Choix de matériaux de qualité',
    svc1_f4: 'Finition soignée et durable',

    svc2_title: 'Décoration de meubles',
    svc2_desc: 'Transformation et embellissement de vos meubles existants avec des techniques traditionnelles et modernes.',
    svc2_f1: 'Peinture décorative',
    svc2_f2: 'Patines et effets vieillis',
    svc2_f3: 'Découpage et marqueterie',
    svc2_f4: 'Application de dorures',

    svc3_title: 'Restauration',
    svc3_desc: 'Redonnez une seconde vie à vos meubles anciens avec notre expertise en restauration et conservation.',
    svc3_f1: 'Diagnostic de l\'état du meuble',
    svc3_f2: 'Réparation structurelle',
    svc3_f3: 'Restauration des finitions',
    svc3_f4: 'Conservation préventive',

    svc4_title: 'Design personnalisé',
    svc4_desc: 'Conception de meubles uniques avec notre équipe de designers expérimentés.',
    svc4_f1: 'Consultation design gratuite',
    svc4_f2: 'Esquisses et maquettes',
    svc4_f3: 'Choix de matériaux',
    svc4_f4: 'Suivi de fabrication',

    svc5_title: 'Finition spécialisée',
    svc5_desc: 'Traitements de surface et finitions haut de gamme pour vos meubles.',
    svc5_f1: 'Vernis et cires naturelles',
    svc5_f2: 'Huiles et teintures',
    svc5_f3: 'Effets de patine',
    svc5_f4: 'Protection UV',

    svc6_title: 'Installation et montage',
    svc6_desc: 'Service complet d\'installation et de montage de vos meubles à domicile.',
    svc6_f1: 'Transport sécurisé',
    svc6_f2: 'Montage professionnel',
    svc6_f3: 'Installation sur site',
    svc6_f4: 'Vérification finale',

    svc7_title: 'Menuiserie',
    svc7_desc: 'Fabrication d\'éléments de menuiserie sur mesure pour vos intérieurs et extérieurs.',
    svc7_f1: 'Portes et fenêtres sur mesure',
    svc7_f2: 'Escaliers et rampes',
    svc7_f3: 'Placards et rangements',
    svc7_f4: 'Éléments décoratifs',

    svc8_title: 'Menuiserie de bâtiment',
    svc8_desc: 'Intervention sur chantiers pour tous types de travaux de menuiserie dans les bâtiments.',
    svc8_f1: 'Installation sur chantier',
    svc8_f2: 'Menuiserie extérieure',
    svc8_f3: 'Menuiserie intérieure',
    svc8_f4: 'Réparations et maintenance',

    services_process_title: 'Notre Processus de Travail',
    proc1_title: 'Consultation',
    proc1_desc: 'Première rencontre pour comprendre vos besoins et votre vision du projet.',
    proc2_title: 'Conception',
    proc2_desc: 'Création de plans détaillés et choix des matériaux appropriés.',
    proc3_title: 'Fabrication',
    proc3_desc: 'Réalisation artisanale avec attention aux détails et à la qualité.',
    proc4_title: 'Livraison',
    proc4_desc: 'Installation et montage professionnel à votre domicile.',

    services_why_title: 'Pourquoi Nous Choisir ?',
    reason1_title: 'Excellence Artisanale',
    reason1_desc: 'Plus de 15 ans d\'expérience dans l\'artisanat du meuble avec un savoir-faire transmis de génération en génération.',
    reason2_title: 'Matériaux de Qualité',
    reason2_desc: 'Nous sélectionnons uniquement les meilleurs matériaux naturels et durables pour garantir la longévité de vos meubles.',
    reason3_title: 'Service Personnalisé',
    reason3_desc: 'Chaque projet est unique. Nous adaptons nos services à vos besoins spécifiques et à votre budget.',
    reason4_title: 'Garantie Qualité',
    reason4_desc: 'Nous nous engageons sur la qualité de nos réalisations avec une garantie satisfait ou remboursé.',

    services_cta_title: 'Prêt à Commencer Votre Projet ?',
    services_cta_subtitle: 'Contactez-nous pour discuter de vos besoins et obtenir un devis personnalisé gratuit.',
    services_cta_gallery_btn: 'Voir nos réalisations',

    // About Page - header (page complète)
    about_page_title: 'À propos de nous',
    about_page_subtitle: 'Découvrez l\'histoire et les valeurs de Senegalaise Deco Meuble',
    about_full_story_p1: 'Senegalaise Deco Meuble est née de la passion d\'Aliou Sene Ngom pour le travail du bois et la création de meubles uniques. Depuis plus de 15 ans, notre atelier situé au cœur de Mbour, sur la route de Joal, perpétue les traditions de l\'artisanat local tout en innovant avec des techniques modernes.',
    about_full_story_p2: 'Notre fondateur, Aliou Sene Ngom, a appris l\'art du meuble auprès de sa famille, transmettant ainsi un savoir-faire ancestral de génération en génération. Cette transmission familiale nous permet de créer des meubles qui allient authenticité sénégalaise et qualité contemporaine.',
    about_full_story_p3: 'Aujourd\'hui, notre équipe d\'artisans passionnés continue cette tradition en créant des pièces uniques qui reflètent l\'âme de l\'artisanat sénégalais tout en répondant aux besoins modernes de nos clients.',
    about_workshop_title: 'Notre Atelier',
    about_feat_tools: 'Outils traditionnels',
    about_feat_wood: 'Bois naturel',
    about_feat_finish: 'Finition artisanale',

    about_val1_title: 'Excellence',
    about_val1_desc: 'Nous visons l\'excellence dans chaque création, en respectant les plus hauts standards de qualité artisanale.',
    about_val2_title: 'Passion',
    about_val2_desc: 'Notre passion pour l\'artisanat nous pousse à créer des pièces uniques qui racontent une histoire.',
    about_val3_title: 'Durabilité',
    about_val3_desc: 'Nous privilégions les matériaux naturels et durables pour garantir la longévité de nos créations.',
    about_val4_title: 'Service Client',
    about_val4_desc: 'La satisfaction de nos clients est notre priorité. Nous écoutons et adaptons nos services à vos besoins.',

    about_team_title: 'Notre Artisan',
    about_team_intro: 'Le maître artisan derrière chaque création',
    about_member_role: 'Propriétaire de l\'Atelier',
    about_member_desc: 'Fondateur et propriétaire de Senegalaise Deco Meuble. Plus de 15 ans d\'expérience dans l\'artisanat du meuble. Transmet son savoir-faire avec passion et dévouement.',

    about_mission_title: 'Notre Mission',
    about_mission_desc: 'Créer des meubles d\'exception qui allient savoir-faire traditionnel et innovation moderne, en respectant l\'environnement et en valorisant les ressources locales. Nous nous engageons à offrir un service personnalisé et une qualité irréprochable à chaque client.',
    about_vision_title: 'Notre Vision',
    about_vision_desc: 'Devenir une référence dans l\'artisanat du meuble au Sénégal, en préservant et transmettant les traditions artisanales tout en développant des créations contemporaines qui s\'exportent au-delà de nos frontières.',

    about_stats_title: 'Nos Chiffres',
    stat_clients_satisfied: 'Clients satisfaits',
    stat_owner: 'Propriétaire expert',

    about_cert_title: 'Nos Engagements',
    cert1_title: 'Qualité Artisanale',
    cert1_desc: 'Chaque pièce est créée avec attention aux détails et respect des techniques traditionnelles.',
    cert2_title: 'Matériaux Durables',
    cert2_desc: 'Nous sélectionnons uniquement des matériaux naturels et durables pour nos créations.',
    cert3_title: 'Service Personnalisé',
    cert3_desc: 'Chaque projet est unique et adapté aux besoins spécifiques de nos clients.',

    // Contact Page - header + contenu complet
    contact_page_title: 'Contactez-nous',
    contact_page_subtitle: 'Discutons de votre projet et obtenez un devis personnalisé',
    contact_form_title: 'Demandez un devis',
    contact_form_subtitle: 'Remplissez le formulaire ci-dessous et nous vous recontacterons dans les plus brefs délais.',
    contact_service_selected: 'Service sélectionné :',
    contact_note_label: 'Note :',
    contact_form_note: 'En cliquant sur "Envoyer ma demande", vous serez redirigé vers WhatsApp pour nous envoyer votre message directement.',
    contact_success_title: 'WhatsApp ouvert !',
    contact_success_desc: 'Votre message a été préparé. Envoyez-le sur WhatsApp et nous vous recontacterons très prochainement.',
    contact_label_name: 'Nom complet',
    contact_label_email: 'Email',
    contact_label_phone: 'Téléphone',
    contact_label_service: 'Service souhaité',
    contact_label_message: 'Description de votre projet',
    contact_placeholder_name: 'Votre nom complet',
    contact_placeholder_message: 'Décrivez votre projet, vos besoins et vos préférences...',
    contact_select_default: 'Sélectionnez un service',
    contact_option_other: 'Autre',
    contact_info_heading: 'Nos coordonnées',
    contact_label_address: 'Adresse',
    contact_label_phone_title: 'Téléphone',
    contact_label_email_title: 'Email',
    contact_label_hours: 'Horaires d\'ouverture',
    contact_hours_weekday: 'Lundi - Vendredi: 8h00 - 18h00',
    contact_hours_saturday: 'Samedi: 8h00 - 16h00',
    contact_hours_sunday: 'Dimanche: Fermé',
    contact_social_title: 'Suivez-nous sur les réseaux sociaux',
    contact_emergency_title: 'Contact d\'urgence',
    contact_emergency_text: 'Pour les demandes urgentes, appelez-nous directement au :',
    contact_map_title: 'Notre localisation',
    contact_map_atelier: 'Atelier Senegalaise Deco Meuble',
    contact_map_howto: 'Comment nous trouver :',
    contact_map_step1: 'Prendre la route de Joal depuis Mbour',
    contact_map_step2: 'Nous sommes situés au kilomètre 1',
    contact_map_step3: 'Atelier visible depuis la route principale',
    contact_map_step4: 'Parking disponible sur place',
    contact_map_btn: 'Voir sur Google Maps',

    // Footer
    footer_tagline: 'Votre atelier d\'artisanat spécialisé dans la création et décoration de meubles traditionnels et modernes à Mbour, Sénégal.',
    footer_quick_links: 'Navigation',
    footer_contact_info: 'Contact',
    footer_rights: 'Tous droits réservés.',
    footer_made_in: 'Fabriqué à la main à Mbour, Sénégal',

    // Refonte 2026 - nouvelles sections
    hero_whatsapp: 'Écrire sur WhatsApp',
    home_film_eyebrow: 'Le film',
    home_film_title: 'L\'atelier en 48 secondes',
    home_film_sub: 'Du bois brut à la pièce posée chez vous : découvrez notre savoir-faire en images.',
    film_play: 'Lire le film',
    film_pause: 'Mettre le film en pause',
    stat_google: 'Note Google',
    home_services_eyebrow: 'Nos métiers',
    home_services_sub: 'De la conception à la pose, un seul atelier pour tout votre mobilier.',
    home_process_eyebrow: 'Savoir-faire',
    home_process_title: 'Du plan à la pose, tout se fait à l\'atelier',
    home_works_eyebrow: 'Réalisations',
    home_works_title: 'Quelques pièces sorties de l\'atelier',
    home_works_link: 'Voir toute la galerie',
    home_workshop_eyebrow: 'L\'atelier',
    home_visit_title: 'Venez nous voir',
    home_directions: 'Itinéraire',
    home_reviews_eyebrow: 'Avis clients',
    home_review_quote: 'Travail très sérieux et rigoureux ! Menuiserie à privilégier dans le secteur.',
    home_review_source: 'Avis client publié sur Google',
    home_reviews_rating_label: 'Note moyenne sur Google',
    home_reviews_link: 'Lire les avis sur Google',
    gallery_eyebrow: 'Galerie',
    gallery_count: 'réalisations',
    gallery_prev: 'Image précédente',
    gallery_next: 'Image suivante',
    gallery_close: 'Fermer',
    services_eyebrow: 'Nos services',
    services_process_eyebrow: 'Méthode',
    services_why_eyebrow: 'Nos engagements',
    about_eyebrow: 'Notre histoire',
    about_values_eyebrow: 'Valeurs',
    about_workshop_caption: 'L\'atelier sur la route de Joal, à Mbour',
    home_workshop_img_alt: 'Façade de l\'atelier de menuiserie sur la route de Joal à Mbour, meubles en bois exposés devant l\'entrée',
    contact_eyebrow: 'Contact',
    contact_map_iframe_title: 'Carte de l\'atelier Senegalaise Deco Meuble à Mbour',

    // Bois laminé (mélaminé / stratifié)
    cat_lamine: 'Bois laminé',
    svc9_title: 'Mobilier en panneaux laminés',
    svc9_desc: 'Cuisines, dressings, bureaux et chambres d\'hôtel en panneaux mélaminés ou stratifiés : un excellent rapport qualité-prix, des délais courts et un entretien facile.',
    svc9_f1: 'Large choix de décors : chêne, noyer, blanc brillant, anthracite, effet béton',
    svc9_f2: 'Panneaux hydrofuges pour cuisines et salles de bain',
    svc9_f3: 'Chants plaqués en machine pour une finition nette et durable',
    svc9_f4: 'Idéal pour les séries : chambres d\'hôtel, bureaux, logements',
    home_lamine_eyebrow: 'Bois laminé',
    home_lamine_title: 'Le sur-mesure à budget maîtrisé',
    home_lamine_desc: 'En plus du bois massif, l\'atelier fabrique du mobilier en panneaux mélaminés et stratifiés. C\'est la solution idéale pour équiper rapidement une cuisine, des placards, des bureaux ou toute une série de chambres d\'hôtel.',
    home_lamine_p1: 'Plus économique que le bois massif',
    home_lamine_p2: 'Résistant à l\'humidité, aux taches et à l\'usure',
    home_lamine_p3: 'Fabrication rapide, idéale pour les séries et les professionnels',
    home_lamine_p4: 'Pose et finitions par notre équipe, clé en main',
    home_lamine_gallery: 'Voir les modèles en bois laminé',
    home_lamine_nuancier_alt: 'Nuancier de décors de panneaux laminés : chêne, noyer, blanc brillant, anthracite, béton',
    gal17_alt: 'Cuisine en panneaux mélaminés chêne clair et blanc brillant',
    gal17_title: 'Cuisine Mélaminé Chêne & Blanc',
    gal17_desc: 'Exemple d\'aménagement réalisable : façades chêne clair en bas, blanc brillant en haut, ouverture sans poignée.',
    gal18_alt: 'Dressing toute hauteur à portes coulissantes en laminé noyer et miroir',
    gal18_title: 'Dressing Coulissant Noyer & Miroir',
    gal18_desc: 'Exemple d\'aménagement réalisable : portes coulissantes, intérieur en mélaminé blanc avec penderie et tiroirs.',
    gal19_alt: 'Meuble TV mural en laminé anthracite et noyer avec éclairage LED',
    gal19_title: 'Meuble TV Anthracite & Noyer',
    gal19_desc: 'Exemple d\'aménagement réalisable : caisson suspendu, étagères assorties et bandeau LED chaleureux.',
    gal20_alt: 'Open space équipé de postes de travail en panneaux laminés',
    gal20_title: 'Bureaux d\'Entreprise',
    gal20_desc: 'Exemple d\'aménagement réalisable : postes de travail, rangements bas et table de réunion pour vos locaux.',
    gal21_alt: 'Chambre d\'hôtel meublée en panneaux laminés effet chêne',
    gal21_title: 'Chambre d\'Hôtel Complète',
    gal21_desc: 'Exemple d\'aménagement réalisable : tête de lit, chevets, bureau, porte-bagages et penderie, fabriqués en série.',
    gal22_alt: 'Meuble de salle de bain en panneaux laminés hydrofuges',
    gal22_title: 'Meuble de Salle de Bain Hydrofuge',
    gal22_desc: 'Exemple d\'aménagement réalisable : façades effet bois résistantes à l\'humidité, vasque et armoire de toilette.',
    gal23_alt: 'Comptoir d\'accueil courbe en lames effet chêne rétroéclairé',
    gal23_title: 'Comptoir d\'Accueil',
    gal23_desc: 'Exemple d\'aménagement réalisable : façade courbe en lames effet chêne et plan blanc, pour hôtels, cliniques et bureaux.',
  },
  en: {
    // Navigation
    nav_home: 'Home',
    nav_services: 'Services',
    nav_gallery: 'Gallery',
    nav_about: 'About',
    nav_contact: 'Contact',
    nav_quote_btn: 'Get a Quote',

    // Hero Section
    hero_badge: 'Artisanal Excellence in Mbour',
    hero_title: 'Custom Hardwood Furniture & Fitting',
    hero_subtitle: 'Bespoke creations combining traditional Senegalese craftsmanship with contemporary design to elevate your living spaces.',
    hero_cta_primary: 'Explore Our Projects',
    hero_cta_secondary: 'Request a Free Quote',

    // Stats
    stat_years: 'Years of Experience',
    stat_projects: 'Projects Completed',
    stat_satisfaction: 'Client Satisfaction',
    stat_guarantee: 'Quality Guarantee',

    // Home Page Features
    home_preview_title: 'Craftsmanship & Services',
    home_about_title: 'An Artisanal Legacy in Mbour',
    home_about_desc: 'Based in Mbour on the road to Joal, our workshop designs and crafts exceptional hardwood furniture (Teak, Mahogany, Iroko). We pay meticulous attention to every joinery detail and finish.',
    home_feature1: '100% selected solid hardwood',
    home_feature2: 'Bespoke finishes and natural protective oils',
    home_feature3: 'Delivery & installation across the Petite Côte and Dakar',
    home_cta_title: 'Have a Furniture Project in Mind?',
    home_cta_desc: 'Contact our craftsmen today to get a free personalized quote.',

    // About Page
    about_title: 'About Sénégalaise Déco',
    about_subtitle: 'Excellence in craftsmanship, passion for wood and cabinetmaking traditions in Mbour.',
    about_story_title: 'Our Story',
    about_story_p1: 'Founded in Mbour on the road to Joal, Sénégalaise Déco Menuiserie perpetuates fine woodworking in Senegal.',
    about_story_p2: 'We combine local timber species with modern aesthetics to build durable art furniture.',
    about_values_title: 'Our Core Values',
    val_quality: 'Uncompromised Quality',
    val_quality_desc: 'Every single piece is meticulously crafted to stand the test of time.',
    val_craft: 'Master Craftsmanship',
    val_craft_desc: 'Traditional cutting and joinery techniques passed down by master artisans.',
    val_custom: 'Full Customization',
    val_custom_desc: 'Tailor-made designs created according to your dimensions, preferences and layouts.',

    // Contact Page
    contact_title: 'Contact Us',
    contact_subtitle: 'Let\'s discuss your project and create your custom dream furniture together.',
    form_name: 'Full Name',
    form_email: 'Email Address',
    form_phone: 'Phone / WhatsApp',
    form_subject: 'Project Subject',
    form_message: 'Your Message / Furniture Details',
    form_submit: 'Send Request',
    form_success: 'Your message was sent successfully! We will contact you shortly.',
    contact_address: 'Workshop Address',
    contact_phone: 'Phone & WhatsApp',
    contact_email: 'Direct Email',
    contact_hours: 'Opening Hours',
    contact_hours_val: 'Mon - Sat: 08:00 AM - 06:00 PM',

    // Gallery Page
    gallery_header_title: 'Our Gallery',
    gallery_header_subtitle: 'Discover our creations and artisanal expertise through our unique showcase',
    cat_all: 'All Creations',
    cat_furniture: 'Custom Furniture',
    cat_kitchen: 'Kitchens',
    cat_decor: 'Decoration & Living',
    cat_renovation: 'Restoration & Renovation',
    gallery_cta_title: 'Interested in a Similar Custom Creation?',
    gallery_cta_subtitle: 'Contact us to discuss your project and get a personalized estimate.',

    // Gallery Page - images (12 creations)
    gal1_alt: 'Monumental dining table in solid teak and mahogany wood',
    gal1_title: 'Exceptional Dining Table',
    gal1_desc: 'A convivial table crafted from solid African teak, with a polished top and a robust hand-made base built in Mbour.',
    gal2_alt: 'Large custom closet in fine wood with hanging space',
    gal2_title: 'Custom Closet & Wardrobe',
    gal2_desc: 'Personalized storage layout with spacious hanging rails and drawers finished in a satin lacquer.',
    gal3_alt: 'Contemporary wall-mounted TV unit and mahogany bookcase',
    gal3_title: 'TV Unit & Wall Bookcase Set',
    gal3_desc: 'An elegant wall structure in solid mahogany combining a sleek TV stand with backlit display shelves.',
    gal4_alt: 'Low storage sideboard in solid wood',
    gal4_title: 'Low Sideboard & Storage Console',
    gal4_desc: 'Functional furniture with clean lines, designed to elevate your living spaces with durable wood.',
    gal5_alt: 'Hand-carved chest of drawers and sideboard in mahogany',
    gal5_title: 'Hand-Carved Artisan Chest',
    gal5_desc: 'An exceptional cabinetmaking piece featuring geometric details hand-carved into fine wood.',
    gal6_alt: 'Solid wood living room set with armchairs and coffee table',
    gal6_title: 'Complete Living Room Set in Fine Wood',
    gal6_desc: 'A matching set including ergonomic armchairs and a central coffee table with authentic charm.',
    gal7_alt: 'Custom integrated kitchen in solid teak with marble countertop',
    gal7_title: 'Teak & Marble Fitted Kitchen',
    gal7_desc: 'A custom kitchen combining the natural strength of fine teak with the elegance of white marble.',
    gal8_alt: 'High-end modular closet with LED lighting',
    gal8_title: 'Premium Closet with LED Lighting',
    gal8_desc: 'A luxurious, modular closet space featuring integrated LED spotlights and refined wood finishes.',
    gal9_alt: 'Artisan coffee table with traditional Senegalese carvings',
    gal9_title: 'Hand-Carved Coffee Table',
    gal9_desc: 'A living room table carved with precision by our master craftsmen, a true joinery masterpiece.',
    gal10_alt: 'Contemporary custom fitted kitchen',
    gal10_title: 'Contemporary Fitted Kitchen',
    gal10_desc: 'A functional, bright kitchen design tailored to the demands of modern homes.',
    gal11_alt: 'Solid fine teak sideboard for dining rooms',
    gal11_title: 'Dining Room Sideboard',
    gal11_desc: 'A spacious sideboard with hinged doors and interior shelving for elegant storage of your tableware.',
    gal12_alt: 'King-size bed and nightstands in solid mahogany',
    gal12_title: 'Master Suite & King-Size Bed',
    gal12_desc: 'A monumental bed frame in fine mahogany with an integrated headboard and matching floating nightstands.',
    gal13_alt: 'Modern kitchen with a marble island, charcoal fronts and walnut wood',
    gal13_title: 'Marble & Walnut Island Kitchen',
    gal13_desc: 'A large veined-marble island with backlit wood cladding, matte charcoal fronts and illuminated glass niches.',
    gal14_alt: 'White shaker kitchen with oak wall cabinets and gold handles',
    gal14_title: 'White, Oak & Brass Kitchen',
    gal14_desc: 'White shaker fronts, oak wall units and lit display cabinets, finished with brushed brass handles.',
    gal15_alt: 'Beige kitchen with a marble island clad in walnut slats',
    gal15_title: 'Open Beige & Walnut Kitchen',
    gal15_desc: 'A central marble island clad in walnut slats, handleless beige fronts and warm LED strips.',
    gal16_alt: 'L-shaped walnut kitchen with a marble backsplash',
    gal16_title: 'L-Shaped Walnut & Marble Kitchen',
    gal16_desc: 'An L-shaped layout optimized for compact spaces, combining walnut fronts with a marble-effect worktop and backsplash.',

    // Services Page
    services_title: 'Our Services',
    services_subtitle: 'Comprehensive woodworking and cabinetmaking expertise to bring your ideas to life.',
    service1_title: 'Bespoke Woodworking',
    service1_desc: 'Design and crafting of unique furniture tailored to your dimensions and needs.',
    service2_title: 'Interior Fitting',
    service2_desc: 'Fitted kitchens, closets, and wall libraries designed to optimize your living space.',
    service3_title: 'Furniture Restoration',
    service3_desc: 'Artistic renovation and noble wood treatment to bring antique furniture back to life.',
    service4_title: 'Integrated Lighting & Finishing',
    service4_desc: 'Built-in LED illumination, varnished or oiled finishes for a luxury look.',

    // Footer
    footer_tagline: 'Craftsmen of bespoke hardwood furniture in Mbour, Senegal.',
    footer_quick_links: 'Quick Links',
    footer_contact_info: 'Contact & Workshop',
    footer_rights: 'All rights reserved.',

    // Services Page - header (full page, distinct from Home preview)
    services_page_subtitle: 'Discover our complete range of furniture craftsmanship services',
    price_on_request: 'On request',

    svc1_title: 'Bespoke Furniture Making',
    svc1_desc: 'Creating personalized furniture to your exact specifications. We tailor every piece to your needs and your space.',
    svc1_f1: 'Precise measurements of your space',
    svc1_f2: 'Design personalized to your style',
    svc1_f3: 'Selection of quality materials',
    svc1_f4: 'Refined, long-lasting finish',

    svc2_title: 'Furniture Decoration',
    svc2_desc: 'Transforming and enhancing your existing furniture with traditional and modern techniques.',
    svc2_f1: 'Decorative painting',
    svc2_f2: 'Patinas and aged effects',
    svc2_f3: 'Marquetry and inlay work',
    svc2_f4: 'Gilding application',

    svc3_title: 'Restoration',
    svc3_desc: 'Give your antique furniture a second life with our restoration and conservation expertise.',
    svc3_f1: 'Condition assessment of the piece',
    svc3_f2: 'Structural repair',
    svc3_f3: 'Finish restoration',
    svc3_f4: 'Preventive conservation',

    svc4_title: 'Custom Design',
    svc4_desc: 'Designing unique furniture with our team of experienced designers.',
    svc4_f1: 'Free design consultation',
    svc4_f2: 'Sketches and mockups',
    svc4_f3: 'Material selection',
    svc4_f4: 'Production follow-up',

    svc5_title: 'Specialized Finishing',
    svc5_desc: 'High-end surface treatments and finishes for your furniture.',
    svc5_f1: 'Natural varnishes and waxes',
    svc5_f2: 'Oils and stains',
    svc5_f3: 'Patina effects',
    svc5_f4: 'UV protection',

    svc6_title: 'Installation & Assembly',
    svc6_desc: 'Full installation and assembly service for your furniture at home.',
    svc6_f1: 'Secure transport',
    svc6_f2: 'Professional assembly',
    svc6_f3: 'On-site installation',
    svc6_f4: 'Final inspection',

    svc7_title: 'Woodworking',
    svc7_desc: 'Custom woodworking elements for your interiors and exteriors.',
    svc7_f1: 'Custom doors and windows',
    svc7_f2: 'Stairs and railings',
    svc7_f3: 'Closets and storage',
    svc7_f4: 'Decorative elements',

    svc8_title: 'Building Carpentry',
    svc8_desc: 'On-site work for all types of carpentry projects in buildings.',
    svc8_f1: 'On-site installation',
    svc8_f2: 'Exterior carpentry',
    svc8_f3: 'Interior carpentry',
    svc8_f4: 'Repairs and maintenance',

    services_process_title: 'Our Work Process',
    proc1_title: 'Consultation',
    proc1_desc: 'A first meeting to understand your needs and vision for the project.',
    proc2_title: 'Design',
    proc2_desc: 'Creating detailed plans and selecting the right materials.',
    proc3_title: 'Crafting',
    proc3_desc: 'Artisanal production with attention to detail and quality.',
    proc4_title: 'Delivery',
    proc4_desc: 'Professional installation and assembly at your home.',

    services_why_title: 'Why Choose Us?',
    reason1_title: 'Artisanal Excellence',
    reason1_desc: 'Over 15 years of experience in furniture craftsmanship, with know-how passed down through generations.',
    reason2_title: 'Quality Materials',
    reason2_desc: 'We only select the finest natural, durable materials to guarantee the longevity of your furniture.',
    reason3_title: 'Personalized Service',
    reason3_desc: 'Every project is unique. We adapt our services to your specific needs and budget.',
    reason4_title: 'Quality Guarantee',
    reason4_desc: 'We stand behind the quality of our work with a satisfaction guarantee.',

    services_cta_title: 'Ready to Start Your Project?',
    services_cta_subtitle: 'Contact us to discuss your needs and get a free personalized quote.',
    services_cta_gallery_btn: 'View Our Work',

    // About Page - header (full page)
    about_page_title: 'About Us',
    about_page_subtitle: 'Discover the story and values of Senegalaise Deco Meuble',
    about_full_story_p1: 'Senegalaise Deco Meuble was born from Aliou Sene Ngom\'s passion for woodworking and creating unique furniture. For over 15 years, our workshop in the heart of Mbour, on the road to Joal, has carried on local craftsmanship traditions while innovating with modern techniques.',
    about_full_story_p2: 'Our founder, Aliou Sene Ngom, learned the art of furniture making from his family, passing down ancestral know-how from generation to generation. This family heritage lets us create furniture that blends Senegalese authenticity with contemporary quality.',
    about_full_story_p3: 'Today, our team of passionate craftsmen continues this tradition, creating unique pieces that reflect the soul of Senegalese craftsmanship while meeting our clients\' modern needs.',
    about_workshop_title: 'Our Workshop',
    about_feat_tools: 'Traditional tools',
    about_feat_wood: 'Natural wood',
    about_feat_finish: 'Artisanal finish',

    about_val1_title: 'Excellence',
    about_val1_desc: 'We strive for excellence in every creation, upholding the highest standards of artisanal quality.',
    about_val2_title: 'Passion',
    about_val2_desc: 'Our passion for craftsmanship drives us to create unique pieces that tell a story.',
    about_val3_title: 'Sustainability',
    about_val3_desc: 'We favor natural, durable materials to ensure the longevity of our creations.',
    about_val4_title: 'Customer Service',
    about_val4_desc: 'Customer satisfaction is our priority. We listen and adapt our services to your needs.',

    about_team_title: 'Our Craftsman',
    about_team_intro: 'The master craftsman behind every creation',
    about_member_role: 'Workshop Owner',
    about_member_desc: 'Founder and owner of Senegalaise Deco Meuble. Over 15 years of experience in furniture craftsmanship. Passes on his expertise with passion and dedication.',

    about_mission_title: 'Our Mission',
    about_mission_desc: 'To create exceptional furniture that blends traditional craftsmanship with modern innovation, respecting the environment and valuing local resources. We are committed to offering personalized service and impeccable quality to every client.',
    about_vision_title: 'Our Vision',
    about_vision_desc: 'To become a benchmark in furniture craftsmanship in Senegal, preserving and passing on artisanal traditions while developing contemporary creations that reach beyond our borders.',

    about_stats_title: 'Our Numbers',
    stat_clients_satisfied: 'Satisfied Clients',
    stat_owner: 'Expert Owner',

    about_cert_title: 'Our Commitments',
    cert1_title: 'Artisanal Quality',
    cert1_desc: 'Every piece is created with attention to detail and respect for traditional techniques.',
    cert2_title: 'Sustainable Materials',
    cert2_desc: 'We only select natural, durable materials for our creations.',
    cert3_title: 'Personalized Service',
    cert3_desc: 'Every project is unique and tailored to our clients\' specific needs.',

    // Contact Page - header + full content
    contact_page_title: 'Contact Us',
    contact_page_subtitle: 'Let\'s discuss your project and get a personalized quote',
    contact_form_title: 'Request a Quote',
    contact_form_subtitle: 'Fill out the form below and we will get back to you as soon as possible.',
    contact_service_selected: 'Selected service:',
    contact_note_label: 'Note:',
    contact_form_note: 'By clicking "Send my request", you will be redirected to WhatsApp to send us your message directly.',
    contact_success_title: 'WhatsApp Opened!',
    contact_success_desc: 'Your message has been prepared. Send it on WhatsApp and we will get back to you very soon.',
    contact_label_name: 'Full Name',
    contact_label_email: 'Email',
    contact_label_phone: 'Phone',
    contact_label_service: 'Desired Service',
    contact_label_message: 'Project Description',
    contact_placeholder_name: 'Your full name',
    contact_placeholder_message: 'Describe your project, needs, and preferences...',
    contact_select_default: 'Select a service',
    contact_option_other: 'Other',
    contact_info_heading: 'Our Contact Details',
    contact_label_address: 'Address',
    contact_label_phone_title: 'Phone',
    contact_label_email_title: 'Email',
    contact_label_hours: 'Opening Hours',
    contact_hours_weekday: 'Monday - Friday: 8:00 AM - 6:00 PM',
    contact_hours_saturday: 'Saturday: 8:00 AM - 4:00 PM',
    contact_hours_sunday: 'Sunday: Closed',
    contact_social_title: 'Follow us on social media',
    contact_emergency_title: 'Emergency Contact',
    contact_emergency_text: 'For urgent requests, call us directly at:',
    contact_map_title: 'Our Location',
    contact_map_atelier: 'Senegalaise Deco Meuble Workshop',
    contact_map_howto: 'How to find us:',
    contact_map_step1: 'Take the road to Joal from Mbour',
    contact_map_step2: 'We are located at kilometer 1',
    contact_map_step3: 'Workshop visible from the main road',
    contact_map_step4: 'Parking available on site',
    contact_map_btn: 'View on Google Maps',

    footer_made_in: 'Handcrafted in Mbour, Senegal',

    // 2026 redesign - new sections
    hero_whatsapp: 'Chat on WhatsApp',
    home_film_eyebrow: 'The film',
    home_film_title: 'Our workshop in 48 seconds',
    home_film_sub: 'From raw timber to the finished piece in your home: see our craftsmanship in motion.',
    film_play: 'Play the film',
    film_pause: 'Pause the film',
    stat_google: 'Google rating',
    home_services_eyebrow: 'What we do',
    home_services_sub: 'From design to installation, one workshop for all your furniture.',
    home_process_eyebrow: 'Craftsmanship',
    home_process_title: 'From plan to installation, everything is made in our workshop',
    home_works_eyebrow: 'Our work',
    home_works_title: 'A few pieces from our workshop',
    home_works_link: 'See the full gallery',
    home_workshop_eyebrow: 'The workshop',
    home_visit_title: 'Come and visit us',
    home_directions: 'Get directions',
    home_reviews_eyebrow: 'Customer reviews',
    home_review_quote: 'Very serious and rigorous work! The carpentry workshop to choose in the area.',
    home_review_source: 'Customer review posted on Google (translated)',
    home_reviews_rating_label: 'Average Google rating',
    home_reviews_link: 'Read reviews on Google',
    gallery_eyebrow: 'Gallery',
    gallery_count: 'pieces',
    gallery_prev: 'Previous image',
    gallery_next: 'Next image',
    gallery_close: 'Close',
    services_eyebrow: 'Our services',
    services_process_eyebrow: 'Method',
    services_why_eyebrow: 'Our commitments',
    about_eyebrow: 'Our story',
    about_values_eyebrow: 'Values',
    about_workshop_caption: 'Our workshop on the road to Joal, in Mbour',
    home_workshop_img_alt: 'Front of the carpentry workshop on the road to Joal in Mbour, wooden furniture displayed at the entrance',
    contact_eyebrow: 'Contact',
    contact_map_iframe_title: 'Map of the Senegalaise Deco Meuble workshop in Mbour',

    // Laminated panels (melamine / HPL)
    cat_lamine: 'Laminated',
    svc9_title: 'Laminated Panel Furniture',
    svc9_desc: 'Kitchens, wardrobes, offices and hotel rooms in melamine or laminate panels: excellent value, short lead times and easy maintenance.',
    svc9_f1: 'Wide choice of finishes: oak, walnut, white gloss, anthracite, concrete effect',
    svc9_f2: 'Moisture-resistant boards for kitchens and bathrooms',
    svc9_f3: 'Machine-applied edge banding for a clean, durable finish',
    svc9_f4: 'Ideal for series: hotel rooms, offices, housing',
    home_lamine_eyebrow: 'Laminated panels',
    home_lamine_title: 'Custom-made on a controlled budget',
    home_lamine_desc: 'Alongside solid wood, our workshop builds furniture in melamine and laminate panels: the ideal way to fit out a kitchen, wardrobes, offices or a whole series of hotel rooms quickly.',
    home_lamine_p1: 'More affordable than solid wood',
    home_lamine_p2: 'Resistant to moisture, stains and wear',
    home_lamine_p3: 'Fast production, ideal for series and professionals',
    home_lamine_p4: 'Installed and finished by our team, turnkey',
    home_lamine_gallery: 'See our laminated designs',
    home_lamine_nuancier_alt: 'Laminate finish samples: oak, walnut, white gloss, anthracite, concrete',
    gal17_alt: 'Kitchen in light oak and white gloss melamine panels',
    gal17_title: 'Oak & White Melamine Kitchen',
    gal17_desc: 'Example of a layout we can build: light oak lower units, white gloss wall units, handleless doors.',
    gal18_alt: 'Floor-to-ceiling sliding wardrobe in walnut laminate and mirror',
    gal18_title: 'Walnut & Mirror Sliding Wardrobe',
    gal18_desc: 'Example of a layout we can build: sliding doors, white melamine interior with hanging rail and drawers.',
    gal19_alt: 'Wall-mounted TV unit in anthracite and walnut laminate with LED lighting',
    gal19_title: 'Anthracite & Walnut TV Unit',
    gal19_desc: 'Example of a layout we can build: floating base unit, matching shelves and warm LED strip.',
    gal20_alt: 'Open-plan office with laminate workstations',
    gal20_title: 'Company Offices',
    gal20_desc: 'Example of a layout we can build: workstations, low storage and a meeting table for your premises.',
    gal21_alt: 'Hotel room furnished in oak-effect laminate panels',
    gal21_title: 'Complete Hotel Room',
    gal21_desc: 'Example of a layout we can build: headboard, bedside tables, desk, luggage rack and wardrobe, made in series.',
    gal22_alt: 'Bathroom vanity unit in moisture-resistant laminate',
    gal22_title: 'Moisture-Resistant Bathroom Unit',
    gal22_desc: 'Example of a layout we can build: wood-effect doors resistant to humidity, basin and mirror cabinet.',
    gal23_alt: 'Curved reception desk in backlit oak-effect slats',
    gal23_title: 'Reception Desk',
    gal23_desc: 'Example of a layout we can build: curved front in oak-effect slats with a white top, for hotels, clinics and offices.',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('sdm_lang') || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('sdm_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLanguage = () => {
    setLang(prevLang => (prevLang === 'fr' ? 'en' : 'fr'));
  };

  const t = (key) => {
    return translations[lang]?.[key] || translations['fr']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
